import { create } from 'zustand';
import { applySystemLanguage } from '../utils/languageUtils';

const useUserStore = create((set) => ({
  user: null,

  setUser: (user) => {
    set({ user });
    if (user?.preferred_language || user?.language) {
      applySystemLanguage(user.preferred_language || user.language);
    }
  },
  
  clearUser: () => set({ user: null }),
}));

export default useUserStore;